import { LogoutOutlined } from '@mui/icons-material';
import {
  Backdrop, Typography,
} from '@mui/material';
import styled from 'styled-components';

const ReferralCode = styled(Typography)`
  && {
    background: -webkit-linear-gradient(45deg,${({ theme }) => theme.palette.primary.main}, ${({ theme }) => theme.palette.info.main});
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: bold;
    text-align: center;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
  }
`;

const DiscountDescription = styled(Typography)`
  && {
    padding-bottom: ${({ theme }) => theme.spacing(2)};
  }
`;

const ContrastLink = styled.a`
  color: ${({ theme }) => theme.palette.backdrop.contrastText};
`;

const DiscountTerms = styled.div`
  && {
    border-top: 1px solid ${({ theme }) => theme.palette.backdrop.dark};
    padding-top: ${({ theme }) => theme.spacing(2)};
  }
`;

const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

const LogoutIcon = styled(LogoutOutlined)`
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

const DetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => theme.spacing(2)};
`;

const FieldRow = styled.div`
  display: flex;
  flex-direction: column;
`;

const FieldName = styled(Typography)`
  && {
    width: 100%;
    color: ${({ theme }) => theme.palette.gray.main};
    font-size: 14px;
    font-weight: 400;
  }
`;

const Title = styled(Typography)`
&& {
  color: ${({ theme }) => theme.palette.darkPrimary.main};
  font-weight: bold;
  margin-top: ${({ theme }) => theme.spacing(2)};
}
`;

const StyledBackdrop = styled(Backdrop)`
  z-index: ${({ theme }) => theme.zIndex.drawer + 1};
`;

const FieldContainer = styled.div`
  margin-left: -${({ theme }) => theme.spacing(2)};
`;

export { TabContainer,
  DetailsSection,
  FieldRow,
  FieldName,
  DiscountTerms,
  StyledBackdrop,
  ReferralCode,
  ContrastLink,
  DiscountDescription,
  LogoutIcon,
  Title,
  FieldContainer };
